import React from 'react';
import './IconButton.css';

export const IconButton = ({ icon, variant, className = '', ...props }) => {
  const variantClass = variant ? `icon-button--${variant}` : '';
  return (
    <button className={`icon-button ${variantClass} ${className}`.trim()} {...props}>
      {icon}
    </button>
  );
}; 